export const useStyles = (theme) => ({
  buttonStyle: {
    variant: "outlined",
    backgroundColor: "#253570 !important",
    outlineColor: "#253570 !important",
    color: "#fff",
    borderRadius: 10,
    fontWeight: "bold",
    fontSize: 15,
    textTransform: "none",
    fontFamily: "Open Sans",
  },
});
